import { useEffect } from 'react';
import { getPasswordStatus, hasPermission, signinRedirectCallback } from '../../services/users/identity/user.service';
import { useHistory } from 'react-router-dom';
import LoadingPage from '../../components/Layout/LoadingPage/LoadingPage.component';
import { UserPermission } from '../../enum/userPermissions';
import { Paths } from '../../utils/routerUrls';
import { UserPasswordStatus } from '../../models/user.types';

function SigninOidc() {
  const history = useHistory();

  const handleGetPasswordStatus = () => {
    getPasswordStatus().then(
      (response: UserPasswordStatus) => {
        if (response === UserPasswordStatus.Expired) {
          history.push(Paths.passwordExpired);
        }
        if (response === UserPasswordStatus.ForcedChange) {
          history.push(Paths.passwordForcedChange);
        }
      },
      (error) => console.log(error),
    );
  };

  useEffect(() => {
    async function signinAsync() {
      try {
        const user = await signinRedirectCallback();
        if (user && !user.profile.password_valid) {
          handleGetPasswordStatus();
        } else if (
          user &&
          hasPermission(user, [UserPermission.AdminPanelManage, UserPermission.ExaminerDashboardRead])
        ) {
          history.push(Paths.selectEnvironment);
        } else if (user && hasPermission(user, UserPermission.ExaminerDashboardRead)) {
          history.push(Paths.dashboard);
        } else if (user && hasPermission(user, UserPermission.AdminPanelManage)) {
          history.push(Paths.adminDashboard);
        } else {
          history.push('/');
        }
      } catch {
        history.push(Paths.login);
      }
    }
    signinAsync();
  }, [history]);

  return <LoadingPage />;
}

export default SigninOidc;
